import { render, staticRenderFns } from "./directMailOrder.vue?vue&type=template&id=6064bdd5&scoped=true&"
import script from "./directMailOrder.vue?vue&type=script&lang=js&"
export * from "./directMailOrder.vue?vue&type=script&lang=js&"
import style0 from "./directMailOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./directMailOrder.vue?vue&type=style&index=1&id=6064bdd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064bdd5",
  null
  
)

export default component.exports